<template>
  <v-container>
    <h3>Personas</h3>
    <br />
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header
          ><h3>
            ¿Cómo ver los detalles de una persona?
          </h3></v-expansion-panel-header
        >
        <v-expansion-panel-content>
          Una vez que se visualice la tabla de Personas, identificar la persona
          que se quiere ver a detalle y hacer click en el ícono
          <v-btn class="mx-2" icon> <v-icon dark>mdi-eye</v-icon> </v-btn>
          en la columna llamada "Ver Detalle".
          <br />
          <v-container class="d-flex justify-center mb-6">
            <v-img
              contain
              max-height="550"
              max-width="1000"
              src="../assets/ViewDetailPointer.png"
            ></v-img>
          </v-container>
          <br />
          Se abrirá una ventana con la información de la persona.
          <br />
          <v-container class="d-flex justify-center mb-6">
            <v-img
              contain
              max-height="550"
              max-width="1000"
              src="../assets/DetailPersonModal.png"
            ></v-img>
          </v-container>
          Para cerrarla, hacer click en cualquier área fuera de la ventana o
          presiona el botón "ESC" de tu teclado.
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <h3>¿Cómo editar una persona?</h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          Una vez que se visualice la tabla de Personas, identificar la persona
          que se quiere editar y hacer click en el ícono
          <v-btn class="mx-2" icon> <v-icon dark>mdi-pencil</v-icon> </v-btn>
          en la columna llamada "Editar".

          <v-img
            contain
            max-height="550"
            max-width="1000"
            src="../assets/PersonEditPointer.png"
          ></v-img>

          <br />

          Al hacer click, se desplegara una ventana donde se podrá visualizar
          toda la información relacionada a una Persona.

          <v-img
            contain
            max-height="550"
            max-width="1000"
            src="../assets/EditPersonModal.png"
          ></v-img>
          <br />

          Para editar un campo, hacer click en el campo que deseas actualizar.
          El campo se pondrá de color azul, como indicador de que es editable.

          <v-img
            contain
            max-height="550"
            max-width="1000"
            src="../assets/EditPersonSelectedField.png"
          ></v-img>

          <br />

          Una vez que se realicen los cambios necesarios, dirigirse a la parte
          inferior de la ventana y hacer click en "Guardar".

          <v-img
            contain
            max-height="550"
            max-width="1000"
            src="../assets/EditPersonSavePointer.png"
          ></v-img>
          <br />

          Se desplegará una alerta en pantalla notificando que la actualización
          de datos ha sido exitosa.

          <v-img
            contain
            max-height="550"
            max-width="1000"
            src="../assets/EditPersonSuccessAlert.png"
          ></v-img>
          <br />

          <h2>Notas:</h2>
          <p>
            No es posible editar el RFC de una persona. Es necesario eliminar a
            la persona y volverla a agregar para poder actualizar el RFC.
          </p>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <h3>¿Cómo eliminar una persona?</h3>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          Una vez que se visualice la tabla de personas, identificar la persona
          que se quiere eliminar y hacer click en el ícono
          <v-btn class="mx-2" icon> <v-icon dark>mdi-delete</v-icon> </v-btn>
          en la columna llamada "Borrar".

          <v-container class="d-flex justify-center mb-6">
            <v-img
              contain
              max-height="550"
              max-width="1000"
              src="../assets/PersonDeletePointer.png"
            ></v-img>
          </v-container>
          <br />
          <br />

          Se abrirá una ventana de confirmación mostrando el nombre de la
          Persona que se desea borrar. Para continuar, haz click en "Eliminar.

          <v-container class="d-flex justify-center mb-6">
            <v-img
              contain
              max-height="550"
              max-width="600"
              src="../assets/DeletePersonButtonPointer.png"
            ></v-img>
          </v-container>
          <br />

          Se desplegará una alerta en pantalla notificando que la Persona ha
          sido eliminada exitosamente.

          <v-container class="d-flex justify-center mb-6">
            <v-img
              contain
              max-height="550"
              max-width="1000"
              src="../assets/DeletePersonSuccessAlert.png"
            ></v-img>
          </v-container>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
export default {
  name: "DocsPersons",

  data: () => ({}),
};
</script>
